import * as API from '../_api';

export const create = async ({ dispatch }, branch) => {
  try {
    await API.create(branch);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const update = async ({ dispatch }, branch) => {
  try {
    await API.update(branch);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const del = async ({ dispatch }, branch) => {
  try {
    await API.del(branch);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};
